
import { z } from 'zod';

export const ContactUsFormSchema = z.object({
    company: z.string().min(1, 'Company is required'),
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    email: z.string().email('Invalid email address'),
    phone: z.string().min(1, 'Phone number is required'),
    message: z.string().min(1, 'Message is required')
});

export type ContactUsForm = z.infer<typeof ContactUsFormSchema>;

export type SignupContactUsResponse = {
    success: boolean;
    form?: Partial<ContactUsForm>;
    alreadySubmitted?: boolean;
    message?: string;
}
